var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldHalf = function SvgShieldHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 38",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.391 3.73a1.19 1.19 0 0 1 1.396.13 17.81 17.81 0 0 0 12.618 4.454l.2.008c.463.057.858.383.993.842a20.19 20.19 0 0 1-14.3 25.235 1.2 1.2 0 0 1-.596 0 20.19 20.19 0 0 1-14.3-25.235l.073-.187a1.19 1.19 0 0 1 1.121-.663 17.81 17.81 0 0 0 12.617-4.453zM19 6.298a20.2 20.2 0 0 1-12.55 4.408 17.81 17.81 0 0 0 6.478 18.284A17.8 17.8 0 0 0 19 32.015a17.8 17.8 0 0 0 6.074-3.025 17.81 17.81 0 0 0 6.477-18.284 20.2 20.2 0 0 1-12.552-4.408"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.813 33.25V4.75a1.188 1.188 0 0 1 2.375 0v28.5a1.188 1.188 0 0 1-2.375 0"
  })));
};
export default SvgShieldHalf;